import styled from 'styled-components';

export const Filter = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
`;

export const PopupContent = styled.div`
  font-size: 13px;
  cursor: default;
  padding: 2px 0px;
  background: white;
  height: 317.5px;
  min-width: 50px;
  max-height: 1000px;
  width: 612px;
  border-radius: 5px;
`;

export const PopupInner = styled.div`
  flex: 1 1 100%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
`;

export const PopupHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  padding: 10px;
  font-weight: 600;
  border-bottom: 1px solid #d7d7d7;
  color: rgba(0, 0, 0, .9);
`;

export const PopupBody = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 100%;
  overflow: hidden;
  max-height: 80vh;
`;

export const PopupSelectContent = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
`;

export const PopupSelect = styled.div`
  width: 90%;
`;

export const PopupListContainer = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column nowrap;
  flex: 1 1 100%;
  overflow-y: auto;
`;
